// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__qegNC","logo":"Header_logo__E8WRn","search":"Header_search__7pkI4","links":"Header_links__HGgTA","link":"Header_link__y5K3N"};